interface Specialty {
  Value?: string;
}

interface FilterOption {
  ControlId?: string;
  Values?: Specialty[];
  Placeholder?: string;
}

interface FilterSet {
  FilterSetName?: string;
  FilterOptions?: FilterOption[];
}

interface SpecialtiesResponse {
  FilterSets?: FilterSet[];
}

export async function fetchSpecialityList(
  id: string,
  filterType: string
): Promise<Record<string, string[]>> {
  if (id == null) return {};
  const url = `https://locator-api.localsearchprofiles.com/api/Configurations/${id}`;

  try {
    const response = await fetch(url, { cache: 'force-cache' });

    if (!response.ok) {
      throw Error(String(response.status));
    }

    const responseJson: SpecialtiesResponse = await response.json();

    const primaryFilterOptions =
      responseJson?.FilterSets?.find((f) => f?.FilterSetName === 'Primary')?.FilterOptions || [];

    const filterOption = primaryFilterOptions.find((option) => option?.ControlId === filterType);

    const filterOptionValues =
      filterOption?.Values?.map((specialty) => specialty?.Value ?? '') ?? [];

    const placeholder = filterOption?.Placeholder || 'default';

    const specialtyItems: Record<string, string[]> = {
      [placeholder]: filterOptionValues,
    };

    return specialtyItems;
  } catch (error) {
    console.error('There has been a problem with your fetch operation:', error);
    return {};
  }
}
